import React from 'react';
import { CompositeTextInput, Popup } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './SearchPopupRenderer.css';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.group.SearchPopupRenderer');
function SearchPopupRenderer(props) {
  const {
    variant,
    focusOnMount,
    search,
    post,
    refreshSearch,
    suggesters,
    listenForEnter,
    setSearch,
    suggestionsVariant,
    onFocus
  } = props;
  const render = onClose => {
    return suggesters.map(sugg => /*#__PURE__*/React.cloneElement(sugg, {
      onClose
    }));
  };
  return /*#__PURE__*/_jsx(Popup, {
    variant: suggestionsVariant,
    navBehavior: "trigger",
    setPopupMinWidth: true,
    setPopupMaxWidth: true
    // eslint-disable-next-line react/no-unstable-nested-components
    ,
    trigger: ({
      ref,
      setOpened,
      isOpened
    }) => {
      const nListenForEnter = evt => {
        // close popup on enter
        setOpened(false);
        listenForEnter(evt);
      };
      return /*#__PURE__*/_jsx("div", {
        className: S.grow,
        onKeyPress: nListenForEnter,
        children: /*#__PURE__*/_jsx(CompositeTextInput, {
          containerRef: ref,
          passFocusTo: "input",
          focus: focusOnMount,
          onFocus: evt => {
            onFocus?.(evt);
            setOpened(true);
          },
          post: post,
          variant: variant || 'search',
          buttonProps: {
            onClick: refreshSearch
          },
          value: search,
          changeOnReturn: false,
          alwaysFireOnReturn: false,
          onChange: ({
            value
          }) => {
            // when the search changes we want to ensure the popup is open
            if (!isOpened) {
              setOpened(true);
            }
            setSearch(value);
          },
          hint: t('hint')
        })
      });
    },
    render: render
  });
}
export default {
  type: 'popup',
  render: SearchPopupRenderer
};